import React, { Dispatch, ReactFragment, SetStateAction, useEffect, useState } from 'react';

import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { ICurrentCity } from '@r1-frontend/ui-react/organisms/NotAuth/types';

import { dataLayerPush } from '../../helpers';
import DefaultPopup from '../defaultPopup';

import * as ST from './styled';

const POLICY_URL = 'https://dom.ru/policy.pdf';

export type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

export interface ISubmitParam {
    fio: string,
    phone: string,
}

interface IProps {
    city?: ICurrentCity,
    isOpen: boolean,
    onClose: () => void,
    title?: string,
    description?: string,
    children?: ReactFragment,
    buttonText?: string,
    waitStatus?: boolean,
    nameInputValue?: string,
    phoneInputValue?: string,
    option: string,
    category: string,
    formFilledHandler?: () => void,
    submitRequest: (param: ISubmitParam) => void,
}

const PopupCallback = ({
    isOpen,
    onClose,
    title,
    description,
    children,
    buttonText,
    formFilledHandler,
    submitRequest,
    option,
    category,
}: IProps) => {

    const [phone, setPhone] = useState<TField>();
    const [name, setName] = useState<TField>();
    const [isValidInputs, setIsValidInputs] = useState(false);
    const [startInput, setStartInput] = useState(false);
    const [waitStatus, setWaitStatus] = useState(true);

    useEffect(() => {
        setIsValidInputs(!!(phone?.isValid && name?.isValid));
        if (phone?.isValid && name?.isValid && formFilledHandler) {
            formFilledHandler();
        }
    }, [phone, name, formFilledHandler]);

    useEffect(() => {
        setStartInput(false);
    }, [option]);

    useEffect(() => {
        if (!isOpen) {
            setWaitStatus(true);
        }
    }, [isOpen]);

    // TODO: Убрать отправку в гугланалитику из компонента ui-react!
    const onChangeHandler = (stateInput: TField, _setState: Dispatch<SetStateAction<TField | undefined>>) => {

        if (!startInput && stateInput.value !== undefined) {
            dataLayerPush({
                event: 'UAevent',
                category,
                action: 'started',
                label: option,
            });
            setStartInput(true);
        }
        _setState(stateInput);
    };

    const submitHandler = (event: { preventDefault: () => void }) => {
        event.preventDefault();
        setWaitStatus(false);

        if (isValidInputs) {
            submitRequest({
                fio: name?.value || '',
                phone: phone?.value || '',
            });

            phone?.clearInput();
            name?.clearInput();

            setPhone(undefined);
            setName(undefined);
        }
    };

    return (
        // @ts-ignore
        <DefaultPopup isOpen={isOpen} onClose={onClose}>
            <ST.Container waitStatus={waitStatus}>
                {title && <ST.Title>{title}</ST.Title>}
                {description && <ST.Description>{description}</ST.Description>}
                <form onSubmit={submitHandler}>
                    {children && <ST.ChildrenBlock>{children}</ST.ChildrenBlock>}
                    <ST.Inputs>
                        <ST.InputName
                            width='50%'
                            onChange={(stateInput: TField) => onChangeHandler(stateInput, setName)}
                            placeholder='Ваше имя'
                            name='name'
                            errorMessage='Укажите ваше имя'
                            required
                        />
                        <ST.InputPhone
                            width='50%'
                            onChange={(stateInput: TField) => onChangeHandler(stateInput, setPhone)}
                            placeholder='Телефон'
                            name='phone1'
                            errorMessage='Укажите ваш телефон'
                        />
                    </ST.Inputs>
                    <ST.LegalWrap>
                        <PolicyNote
                            buttonText={buttonText}
                            agreeUrl={POLICY_URL}
                        />
                    </ST.LegalWrap>
                    <ST.Button
                        type='accent'
                        text={buttonText}
                        disabled={!isValidInputs || !waitStatus}
                    />
                </form>
                <Throbber waitStatus={waitStatus} position={'absolute'} />
            </ST.Container>
        </DefaultPopup>
    );
};

export default PopupCallback;
